const componentsCommon = require("cb-components-common").default;
const request = componentsCommon.request;

export function getFundRank(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/rank",
        method: "get",
        params: _params
    });
}

export function getLatestDate(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/rank/getLatestDate",
        method: "get",
        params: _params
    });
}

export function rankDownload(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/rank-download",
        method: "get",
        params: _params
    });
}

export function getMonthlyReportFixed(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/monthly-report-fixed",
        method: "get",
        params: _params
    });
}

export function getSubscription(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/rank-subscription",
        method: "get",
        params: _params
    });
}

export function editSubscription(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/rank-subscription",
        method: "put",
        data: _params
    });
}

export function getSubscriptionMonthly(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/rank-subscription-monthly",
        method: "get",
        params: _params
    });
}

export function editSubscriptionMonthly(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/rank-subscription-monthly",
        method: "put",
        data: _params
    });
}

export function sendRankReportByEmail(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/send-rank-report-by-email",
        method: "get",
        params: _params
    });
}

export function sendRankReportByEmailMonthly(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/send-rank-report-by-email-monthly",
        method: "get",
        params: _params
    });
}

export function getCategoryList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/display-category-list",
        method: "get",
        params: _params
    });
}
